import { render, staticRenderFns } from "./setting-form.vue?vue&type=template&id=44d72104&scoped=true&"
import script from "./setting-form.vue?vue&type=script&lang=js&"
export * from "./setting-form.vue?vue&type=script&lang=js&"
import style0 from "./setting-form.vue?vue&type=style&index=0&id=44d72104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d72104",
  null
  
)

export default component.exports